import { PremiumElement } from '../../types/PremiumElement';
import {
    HalvCoveragesIds,
    HelCoveragesIds,
    PlusCoveragesIds,
    TrafikCoveragesIds
} from '../../types/enums/products/car/coverages';
import { getText } from '../text/text-service';
import { PaymentTerms } from '../../types/enums/PaymentTerms';
import ProductsNumbers from '../../types/enums/productsNumbers';

export const preparePrice = (
    premiumList: PremiumElement[],
    paymentTerm: PaymentTerms,
    maxPrice: number,
    ids: any,
    minPrice?: number,
    productNumber?: any
): number | string => {
    let price = premiumList
        .filter(pe => pe.coverageProduct in ids)
        .reduce((a, b) => a + b.premium, 0);
    if (paymentTerm && price * paymentTerm >= maxPrice) {
        if (productNumber && productNumber == ProductsNumbers.VILLA) {
            return getText('webshopsweden.products.villaHome.priceToHigh');
        }
        if (productNumber && productNumber == ProductsNumbers.MOTORCYCLE) {
            return getText('webshopsweden.products.motorcycle.priceToHigh');
        } else {
            return getText(
                'webshopsweden.products.car.insurance.priceToHighContactUs'
            );
        }
    }
    if (minPrice && price * paymentTerm <= minPrice) {
        if (productNumber && productNumber == ProductsNumbers.MOTORCYCLE) {
            return getText('webshopsweden.products.motorcycle.priceToHigh');
        } else {
            return getText(
                'webshopsweden.products.car.insurance.priceToHighContactUs'
            );
        }
    }
    return price;
};

export const prepareTrafikPrice = (
    premiumList: PremiumElement[],
    paymentTerm: PaymentTerms
): number | string => {
    return preparePrice(premiumList, paymentTerm, 10000, TrafikCoveragesIds);
};

export const prepareHalvPrice = (
    premiumList: PremiumElement[],
    paymentTerm: PaymentTerms
): number | string => {
    return preparePrice(premiumList, paymentTerm, 15000, HalvCoveragesIds);
};

export const prepareHelPrice = (
    premiumList: PremiumElement[],
    paymentTerm: PaymentTerms
): number | string => {
    return preparePrice(premiumList, paymentTerm, 20000, HelCoveragesIds);
};

export const preparePlusPackagePrice = (
    premiumList: PremiumElement[]
): number | string => {
    return preparePrice(premiumList, null, null, PlusCoveragesIds);
};

export const resolvePaymentTerm = (
    paymentTerm: number,
    price,
    fullName?: boolean
): string => {
    if (typeof price === 'string') {
        return '';
    }
    if (Number(paymentTerm) == 12) {
        if (fullName) {
            return getText('webshopsweden.common.payment.fullMonth');
        } else {
            return getText('webshopsweden.common.payment.month');
        }
    } else if (Number(paymentTerm) == 2) {
        return getText('webshopsweden.common.payment.halfYear');
    } else if (Number(paymentTerm) == 4) {
        return getText('webshopsweden.common.payment.quarter');
    } else if (Number(paymentTerm) == 1) {
        return getText('webshopsweden.common.payment.year');
    } else {
        return null;
    }
};

export const resolveCarInsurance = (
    trafikRemark: boolean,
    halvRemark: boolean
): string => {
    if (trafikRemark) {
        return getText('webshopsweden.products.car.insurance.trafikInsurance');
    } else if (halvRemark) {
        return getText('webshopsweden.products.car.insurance.halvInsurance');
    } else {
        return getText('webshopsweden.products.car.insurance.helInsurance');
    }
};

export const resolvePriceForPaymentTerm = (
    price: number,
    paymentTerm: PaymentTerms,
    summaryField: PaymentTerms
): number => {
    if (paymentTerm != summaryField) {
        switch (paymentTerm) {
            case PaymentTerms.YEAR:
                switch (summaryField) {
                    case PaymentTerms.HALFYEAR:
                        return Math.round(price / 2);
                    case PaymentTerms.QUARTER:
                        return Math.round(price / 4);
                    case PaymentTerms.MONTHLY:
                        return Math.round(price / 12);
                }
            case PaymentTerms.HALFYEAR:
                switch (summaryField) {
                    case PaymentTerms.YEAR:
                        return Math.round(price * 2);
                    case PaymentTerms.QUARTER:
                        return Math.round(price / 2);
                    case PaymentTerms.MONTHLY:
                        return Math.round(price / 6);
                }
            case PaymentTerms.QUARTER:
                switch (summaryField) {
                    case PaymentTerms.YEAR:
                        return Math.round(price * 4);
                    case PaymentTerms.HALFYEAR:
                        return Math.round(price * 2);
                    case PaymentTerms.MONTHLY:
                        return Math.round(price / 3);
                }
            case PaymentTerms.MONTHLY:
                switch (summaryField) {
                    case PaymentTerms.YEAR:
                        return Math.round(price * 12);
                    case PaymentTerms.HALFYEAR:
                        return Math.round(price * 6);
                    case PaymentTerms.QUARTER:
                        return Math.round(price * 3);
                }
        }
    }
    return Math.round(price);
};
